<template>
    <table class="table table-condensed">
        <thead>
        <tr>
            <th>Nazwa</th>
            <th>Cena</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in results">
            <td>
                <a :href="item.link" target="_blank">{{item.name}}</a>
            </td>
            <td>{{item.price}}</td>
        </tr>
        </tbody>
    </table>
</template>

<script>

    import {product} from '../../services'

    export default {

        data() {
            return {
                results: []
            }
        },
        mounted() {
            product.getSimilar(this, this.id, response => {
                this.results = response.body;
            })
        },
        methods: {}
    }

</script>



// WEBPACK FOOTER //
// SimilarProducts.vue?31487556